(() => {
  const announcement = document.querySelector('.v2-announcement');
  if (announcement) {
    const messages = [...announcement.querySelectorAll('[data-announcement]')];
    const toggle = announcement.querySelector('.v2-announcement-toggle');
    let current = 0, timer, visible = true;
    let paused = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sync = () => {
      clearInterval(timer);
      toggle.setAttribute('aria-label', paused ? 'Play announcements' : 'Pause announcements');
      toggle.querySelector('path').setAttribute('d', paused ? 'm9 5 10 7-10 7Z' : 'M9 5v14M15 5v14');
      if (!paused && visible && !document.hidden) timer = setInterval(() => {
        messages[current].hidden = true;
        current = (current + 1) % messages.length;
        messages[current].hidden = false;
      }, 5000);
    };
    toggle.hidden = messages.length < 2;
    toggle.addEventListener('click', () => { paused = !paused; sync(); });
    document.addEventListener('visibilitychange', sync);
    new IntersectionObserver(([entry]) => { visible = entry.isIntersecting; sync(); }).observe(announcement);
    sync();
  }
  const form = document.querySelector('#v2-product-form');
  if (!form) return;
  const radios = [...form.querySelectorAll('input[name="id"]')];
  const submits = [...document.querySelectorAll('.v2-add, .v2-sticky button')];
  const message = form.querySelector('.v2-form-message');
  const purchase = form.querySelector('[data-pw-subscription]');
  const commerce = JSON.parse(purchase.querySelector('[data-pw-commerce]').textContent);
  const modes = [...purchase.querySelectorAll('[data-pw-mode]')];
  const planSelect = purchase.querySelector('[data-pw-plan]');
  const summary = purchase.querySelector('[data-pw-summary]');
  let mode = modes.find(input => input.checked)?.value || 'onetime';
  let previousVariant;
  let busy = false;
  const variantFor = input => commerce.variants.find(variant => variant.id === input?.value);
  const planFor = variant => variant?.plans.find(plan => plan.id === planSelect.value);
  function selection() {
    const choice = radios.find(input => input.checked);
    const variant = variantFor(choice);
    const plan = mode === 'subscribe' ? planFor(variant) : null;
    const price = mode === 'subscribe' ? plan?.price : variant?.price;
    let error = '';
    if (!variant || !variant.available || choice.disabled) error = 'This pack is currently unavailable.';
    else if (mode === 'subscribe' && !plan) error = commerce.requiresPlan || variant.requiresPlan ? 'Subscription unavailable for this pack. Choose another pack.' : 'Subscription unavailable for this pack. Choose another pack or one-time purchase.';
    else if (mode === 'onetime' && (commerce.requiresPlan || variant.requiresPlan)) error = 'This pack requires a subscription. Select Subscribe & save.';
    else if (!(variant.price > 0) || !(price > 0)) error = 'This pack is currently unavailable.';
    return {choice, variant, plan, error};
  }
  function syncPack() {
    const choice = radios.find(input => input.checked);
    const variant = variantFor(choice);
    if (!variant) return;
    if (previousVariant !== variant.id) {
      const previousPlan = planSelect.value;
      planSelect.replaceChildren(...variant.plans.map(plan => new Option(plan.name, plan.id)));
      planSelect.value = variant.plans.some(plan => plan.id === previousPlan) ? previousPlan : variant.plans[0]?.id || '';
      previousVariant = variant.id;
    }
    // Keep the shopper's purchase mode even when the new pack cannot support it.
    const allocatedPlan = planFor(variant);
    modes.forEach(input => {
      const subscription = input.value === 'subscribe';
      input.checked = input.value === mode;
      input.disabled = subscription ? !variant.plans.length : Boolean(commerce.requiresPlan || variant.requiresPlan);
      const card = purchase.querySelector(`[data-pw-offer="${input.value}"]`);
      card.hidden = input.disabled;
      card.classList.toggle('is-selected', input.checked);
    });
    planSelect.disabled = mode !== 'subscribe' || !allocatedPlan;
    const saving = allocatedPlan && variant.price > allocatedPlan.price && variant.price > 0 ? Math.round((variant.price - allocatedPlan.price) * 100 / variant.price) : 0;
    purchase.querySelector('[data-pw-sub-title]').textContent = saving > 0 ? 'Subscribe & save' : 'Subscribe';
    purchase.querySelector('[data-pw-sub-price]').textContent = allocatedPlan?.formattedPrice || '';
    const subOld = purchase.querySelector('[data-pw-sub-old]');
    subOld.textContent = variant.formattedPrice;
    subOld.hidden = saving <= 0;
    const badge = purchase.querySelector('[data-pw-saving]');
    badge.textContent = `Save ${saving}%`;
    badge.hidden = saving <= 0;
    purchase.querySelector('[data-pw-ot-price]').textContent = variant.formattedPrice;
    const oldPrice = purchase.querySelector('[data-pw-ot-old]');
    oldPrice.textContent = variant.formattedCompareAt;
    oldPrice.hidden = !(variant.compareAt > variant.price);
    const state = selection();
    const formattedPrice = mode === 'subscribe' ? allocatedPlan?.formattedPrice || 'Unavailable' : variant.formattedPrice;
    document.querySelectorAll('[data-active-price]').forEach(el => { el.textContent = formattedPrice; });
    document.querySelectorAll('[data-active-pack]').forEach(el => { el.textContent = choice.dataset.name; });
    document.querySelectorAll('[data-active-mode]').forEach(el => { el.textContent = mode === 'subscribe' ? allocatedPlan?.name || 'Subscription unavailable' : 'One-time purchase'; });
    // The pack cards reflect the active mode, using the same plan across packs.
    radios.forEach(input => {
      const pack = variantFor(input);
      const packPrice = mode === 'subscribe' ? (pack?.plans.find(plan => plan.id === allocatedPlan?.id) || pack?.plans[0])?.formattedPrice : pack?.formattedPrice;
      const prices = input.closest('.v2-pack')?.querySelector('.v2-pack-prices');
      if (prices) {
        prices.querySelector('strong').textContent = packPrice || 'Unavailable';
        const old = prices.querySelector('s');
        if (old) old.hidden = mode === 'subscribe' || !(pack.compareAt > pack.price);
      }
    });
    summary.textContent = state.error || (mode === 'subscribe' ? `${formattedPrice} · ${allocatedPlan.name}` : 'One-time purchase. No recurring charges.');
    submits.forEach(button => { button.disabled = busy || Boolean(state.error); });
    document.querySelectorAll('[data-add-label]').forEach(el => { el.textContent = busy ? 'Adding…' : state.error ? 'Unavailable' : mode === 'subscribe' ? (el.closest('.v2-sticky') ? 'Subscribe' : 'Subscribe & add to cart') : 'Add to cart'; });
  }
  function changeSelection() {
    message.hidden = true;
    message.textContent = '';
    form.querySelector('.v2-cart-success').hidden = true;
    syncPack();
  }
  radios.forEach(input => input.addEventListener('change', changeSelection));
  modes.forEach(input => input.addEventListener('change', () => { if (input.checked) mode = input.value; changeSelection(); }));
  planSelect.addEventListener('change', changeSelection);
  syncPack();
  form.addEventListener('submit', async event => {
    const state = selection();
    if (busy || state.error) {
      event.preventDefault();
      return;
    }
    // The enabled selling_plan select is also the native form's source of truth.
    if (typeof window.fetch !== 'function') return;
    event.preventDefault();
    const item = {id:Number(state.variant.id),quantity:1};
    if (mode === 'subscribe') item.selling_plan = Number(state.plan.id);
    const selectedName = state.choice.dataset.name;
    const selectedMode = mode === 'subscribe' ? ` (${state.plan.name})` : '';
    busy = true; syncPack();
    message.hidden = true;
    form.querySelector('.v2-cart-success').hidden = true;
    let drawerOpened = false;
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items:[item],sections:window.dpV2Cart ? [window.dpV2Cart.section] : [],sections_url:location.pathname})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'This pack could not be added. Please try again.');
      message.textContent = `${selectedName}${selectedMode} added to your cart.`;
      if (window.dpV2Cart) drawerOpened = await window.dpV2Cart.open({sections:result.sections,trigger:event.submitter,added:true});
      form.querySelector('.v2-cart-success').hidden = drawerOpened;
    } catch (error) {
      message.textContent = error.message || 'We couldn’t connect to your cart. Please try again.';
    } finally {
      busy = false; syncPack(); message.hidden = drawerOpened;
      if (!drawerOpened) {
        message.focus({preventScroll:true});
        message.scrollIntoView({block:'center',behavior:'auto'});
      }
    }
  });
  const gallery = document.querySelector('.v2-gallery-track');
  const thumbs = [...document.querySelectorAll('[data-photo]')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const videos = [...document.querySelectorAll('video[data-autoplay]')];
  if (!reduced && !navigator.connection?.saveData) {
    const visibleVideos = new Set();
    const syncVideo = video => {
      if (visibleVideos.has(video) && !document.hidden) {
        video.muted = true;
        video.play().catch(() => {}); // Native controls remain available if autoplay is blocked.
      } else {
        video.pause();
      }
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(({target, intersectionRatio}) => {
        if (intersectionRatio >= 0.4) visibleVideos.add(target);
        else visibleVideos.delete(target);
        syncVideo(target);
      });
    }, {threshold: [0, 0.4]});
    videos.forEach(video => observer.observe(video));
    document.addEventListener('visibilitychange', () => videos.forEach(syncVideo));
  }
  function showPhoto(index) {gallery.scrollTo({left:gallery.clientWidth * index,behavior:reduced ? 'auto':'smooth'});}
  // Touch gestures move at most one slide; native vertical page scrolling stays available.
  let drag;
  gallery.addEventListener('pointerdown', event => {
    if (!event.isPrimary || event.pointerType === 'mouse') return;
    drag = {id:event.pointerId,x:event.clientX,y:event.clientY,index:Math.round(gallery.scrollLeft / gallery.clientWidth),dx:0,horizontal:false};
  });
  gallery.addEventListener('pointermove', event => {
    if (!drag || event.pointerId !== drag.id) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (!drag.horizontal) {
      if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
      if (Math.abs(dx) < 8 || Math.abs(dx) < Math.abs(dy) * 1.2) return;
      drag.horizontal = true;
      gallery.setPointerCapture(event.pointerId);
      gallery.classList.add('is-dragging');
      gallery.scrollTo({left:drag.index * gallery.clientWidth,behavior:'instant'});
    }
    drag.dx = dx;
    gallery.scrollLeft = drag.index * gallery.clientWidth - Math.max(-gallery.clientWidth, Math.min(gallery.clientWidth,dx));
  });
  const endDrag = event => {
    if (!drag || event.pointerId !== drag.id) return;
    const gesture = drag; drag = null;
    if (!gesture.horizontal) return;
    const step = event.type !== 'pointercancel' && Math.abs(gesture.dx) >= 36 ? (gesture.dx < 0 ? 1 : -1) : 0;
    const next = Math.max(0,Math.min(thumbs.length-1,gesture.index+step));
    gallery.classList.remove('is-dragging');
    showPhoto(next);
  };
  gallery.addEventListener('pointerup', endDrag);
  gallery.addEventListener('pointercancel', endDrag);
  thumbs.forEach((button,index) => button.addEventListener('click', () => showPhoto(index)));
  gallery.addEventListener('scroll', () => {const index = Math.round(gallery.scrollLeft / gallery.clientWidth); thumbs.forEach((button,i) => button.setAttribute('aria-pressed',String(i === index)));}, {passive:true});
  gallery.addEventListener('keydown', event => {if (!['ArrowLeft','ArrowRight'].includes(event.key)) return; event.preventDefault();const index = Math.round(gallery.scrollLeft/gallery.clientWidth);showPhoto(Math.max(0,Math.min(thumbs.length-1,index+(event.key==='ArrowRight'?1:-1))));});
  const tabs = [...document.querySelectorAll('[data-benefit]')];
  function selectBenefit(index) {tabs.forEach((tab,i) => {tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;document.getElementById(`benefit-${i}`).hidden=i!==index;});}
  tabs.forEach((tab,index) => {tab.addEventListener('click',()=>selectBenefit(index));tab.addEventListener('keydown',event=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:tabs.length-1))%tabs.length;selectBenefit(next);tabs[next].focus();});});
  const storyButtons = [...document.querySelectorAll('[data-story]')];
  const mini = document.querySelector('.v2-comments');
  if (mini) {
    const slides = [...mini.querySelectorAll('[data-mini-slide]')];
    const photos = [...mini.querySelectorAll('[data-mini-photo]')];
    let index = 0;
    const show = next => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide,i) => { slide.hidden = i !== index; });
      photos.forEach((photo,i) => photo.setAttribute('aria-pressed', String(i === index)));
      mini.querySelector('[data-mini-count]').textContent = `${index + 1} / ${slides.length}`;
    };
    mini.querySelector('[data-mini-prev]').addEventListener('click', () => show(index - 1));
    photos.forEach((photo,i) => photo.addEventListener('click', () => show(i)));
    mini.querySelector('[data-mini-next]').addEventListener('click', () => show(index + 1));
    let start;
    mini.addEventListener('touchstart', e => { start = {x:e.touches[0].clientX,y:e.touches[0].clientY}; }, {passive:true});
    mini.addEventListener('touchend', e => {
      if (!start) return;
      const dx = e.changedTouches[0].clientX - start.x, dy = e.changedTouches[0].clientY - start.y;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) show(index + (dx < 0 ? 1 : -1));
      start = null;
    }, {passive:true});
  }
  let storyIndex = 0;
  function showStory(index) {
    if (!storyButtons.length) return;
    storyIndex = (index + storyButtons.length) % storyButtons.length;
    storyButtons.forEach((button,i) => {
      button.setAttribute('aria-pressed',String(i===storyIndex));
      const panel = document.getElementById(`v2-story-${i}`);
      panel.hidden = i !== storyIndex;
      if (panel.hidden) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    document.querySelector('[data-story-count]').textContent = `${storyIndex+1} / ${storyButtons.length}`;
  }
  storyButtons.forEach((button,index) => button.addEventListener('click',()=>showStory(index)));
  document.querySelector('[data-story-prev]')?.addEventListener('click',()=>showStory(storyIndex-1));
  document.querySelector('[data-story-next]')?.addEventListener('click',()=>showStory(storyIndex+1));
  const story = document.querySelector('.v2-story-review');
  document.addEventListener('visibilitychange', () => {
    if (document.hidden) story?.querySelectorAll('video').forEach(video => video.pause());
  });
  let touchStart;
  story?.addEventListener('touchstart',event=>{touchStart={x:event.touches[0].clientX,y:event.touches[0].clientY};},{passive:true});
  story?.addEventListener('touchend',event=>{if(!touchStart)return;const dx=event.changedTouches[0].clientX-touchStart.x,dy=event.changedTouches[0].clientY-touchStart.y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy)*1.5)showStory(storyIndex+(dx<0?1:-1));touchStart=null;},{passive:true});
})();
